var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConstraintNode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Constraint_Node") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grid-Editor_st2",
    transform: "translate(-825.000000, -424.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(447.000000, 229.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M403,195 L379,195 C378.448,195 378,195.448 378,196 L378,220 C378,220.552 378.448,221 379,221 L403,221 C403.552,221 404,220.552 404,220 L404,196 C404,195.448 403.552,195 403,195 Z M385,218 C383.3455,218 382,216.6545 382,215 C382,213.3455 383.3455,212 385,212 C386.6545,212 388,213.3455 388,215 C388,216.6545 386.6545,218 385,218 Z M383,209 C383,208.448 383.448,208 384,208 C384,207.448 384.448,207 385,207 C385.552,207 386,207.448 386,208 C386.552,208 387,208.448 387,209 C387,209.552 386.552,210 386,210 C386,210.552 385.552,211 385,211 C384.448,211 384,210.552 384,210 C383.448,210 383,209.552 383,209 Z M397,218 C395.3455,218 394,216.6545 394,215 C394,213.3455 395.3455,212 397,212 C398.6545,212 400,213.3455 400,215 C400,216.6545 398.6545,218 397,218 Z M395,209 C395,208.448 395.448,208 396,208 L398,208 C398.552,208 399,208.448 399,209 C399,209.552 398.552,210 398,210 L396,210 C395.448,210 395,209.552 395,209 Z M400,205 C400,205.552 399.552,206 399,206 L383,206 C382.448,206 382,205.552 382,205 L382,199 C382,198.448 382.448,198 383,198 L399,198 C399.552,198 400,198.448 400,199 L400,205 Z M397,216 C397.552285,216 398,215.552285 398,215 C398,214.447715 397.552285,214 397,214 C396.447715,214 396,214.447715 396,215 C396,215.552285 396.447715,216 397,216 Z M385,216 C385.552285,216 386,215.552285 386,215 C386,214.447715 385.552285,214 385,214 C384.447715,214 384,214.447715 384,215 C384,215.552285 384.447715,216 385,216 Z M384,204 L390.586,204 L393.293,201.293 C393.6835,200.9025 394.3165,200.9025 394.707,201.293 C395.0975,201.6835 395.0975,202.3165 394.707,202.707 L393.414,204 L398,204 L398,200 L384,200 L384,204 Z",
    id: "Constraint_Node"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConstraintNode);
export default __webpack_public_path__ + "static/media/Constraint_Node.3fdec419d815ea03a0166c8fb423f509.svg";
export { ForwardRef as ReactComponent };